"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.Alarms = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    alarms: state.informationLists.alarms
  };
};

exports.mapStateToProps = mapStateToProps;

var Alarms = function Alarms(_ref) {
  var tour = _ref.tour,
      alarms = _ref.alarms;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0 px-1 pb-1"
  }, tour.alarms.map(function (alarmId) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alarm-name",
      key: alarmId
    }, (alarms.find(function (alarm) {
      return alarm.id === alarmId;
    }) || {}).name);
  }));
};

exports.Alarms = Alarms;
Alarms.propTypes = {
  tour: _propTypes["default"].shape({
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired)
  }).isRequired,
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string
  })).isRequired
};
Alarms.defaultProps = {};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Alarms);

exports["default"] = _default;